import { highlightPresetRegistry } from './highlightPreset';

export const getHighlightColorsArray = (
  min: number,
  max: number,
  levels: number,
): { value: number; fillColor: string; textColor: string }[] => {
  const preset =
    highlightPresetRegistry[
      `${levels}` as keyof typeof highlightPresetRegistry
    ];
  const step = (max - min) / levels;

  return Array.from({ length: levels }, (_, i) => ({
    value: min + (i + 1) * step,
    fillColor: preset[i].fillColor,
    textColor: preset[i].textColor,
  }));
};
